<template>
	<section class="gxzz-news" aria-label="站内头条">
		<div class="gxzz-news__header">
			<div class="gxzz-news__title">站内头条</div>
			<a class="gxzz-news__more" href="/gxzz/topstory">更多 &gt;</a>
		</div>

		<a
			v-for="(item, index) in displayList"
			:key="item.informationId ?? item.announcementId ?? item.id ?? `${item.title || ''}-${index}`"
			class="gxzz-news__item"
			:href="buildNoticeItemHref(item, { loggedIn: isLoggedIn, isGxzz: true })"
		>
			<div class="gxzz-news__item-title">{{ item.title }}</div>
			<div class="gxzz-news__item-time">{{ getDisplayTime(item) }}</div>
		</a>
	</section>
</template>

<script setup>
import { computed } from 'vue';
import { buildNoticeItemHref } from '@/utils/link/noticeDetail';

/** 登录态用 cookie：SSR 与客户端首屏一致 */
const tokenCookie = useCookie('cmdc_access_token_mobile');
const isLoggedIn = computed(() => !!tokenCookie.value);

const props = defineProps({
	companyId: {
		type: [String, Number],
		default: '',
	},
	newsList: {
		type: Array,
		default: () => [],
	},
});

const displayList = computed(() => props.newsList.filter(item => item?.title).slice(0, 5));

const getDisplayTime = item => item?.publishTime || item?.publishDate || item?.releaseTime || item?.createTime || '';
</script>

<style scoped lang="scss">
.gxzz-news {
	margin: 0;
	margin-top: 0.75rem;
	background: #fff;
	overflow: hidden;
}

.gxzz-news__header {
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 1rem;
	padding-bottom: 0.75rem;
}

.gxzz-news__title {
	font-size: 1.5rem;
	font-weight: 700;
	line-height: 2.17rem;
	color: #333;
}

.gxzz-news__more {
	border: none;
	background: transparent;
	padding: 0;
	font-size: 1rem;
	line-height: 1.5rem;
	color: #86909c;
	text-decoration: none;
	cursor: pointer;
}

.gxzz-news__item {
	display: flex;
	align-items: flex-start;
	gap: 0.75rem;
	width: 100%;
	padding: 0.83rem 1rem;
	border: none;
	border-top: 0.08rem solid #f2f3f5;
	background: #fff;
	text-align: left;
	text-decoration: none;
	color: inherit;
	cursor: pointer;
}

.gxzz-news__item-title {
	flex: 1;
	min-width: 0;
	font-size: 1rem;
	line-height: 1.5rem;
	color: #333;
	word-break: break-all;
	display: -webkit-box;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;
	overflow: hidden;
}

.gxzz-news__item-time {
	flex-shrink: 0;
	font-size: 1rem;
	line-height: 1.5rem;
	color: #999;
	white-space: nowrap;
}
</style>
